// Mock data for Barnum Événement - Complete Website

export const siteInfo = {
  name: "Barnum Événement",
  tagline: "Votre événement, Notre expertise",
  description: "Location de matériel événementiel professionnel en Normandie. Barnums, chapiteaux, mobilier, décoration. Devis gratuit. Service de qualité depuis 2015.",
  phone: "06 98 43 09 92",
  email: "contact@barnum-evenement.fr",
  address: "40 rue de la Libération, 76700 Gainneville",
  catalogueUrl: "https://heyzine.com/flip-book/b1a599dc29.html"
};

export const navigation = [
  { name: "Accueil", href: "/" },
  { name: "Catalogue", href: "/catalogue", hasDropdown: true },
  { name: "Nos Réalisations", href: "/realisations" },
  { name: "Blog", href: "/blog" },
  { name: "FAQ", href: "/faq" },
  { name: "À Propos", href: "/a-propos" }
];

export const catalogueCategories = [
  {
    id: "barnums",
    name: "Barnum et Tentes de Réception",
    slug: "barnums-tentes",
    description: "Chapiteaux, barnums pliants, tentes stretch pour tous vos événements",
    image: "https://images.unsplash.com/photo-1675376616537-c8aa9ddc9977?w=600&h=400&fit=crop",
    featured: true
  },
  {
    id: "mobilier",
    name: "Mobilier et Vaisselle",
    slug: "mobilier-deco",
    description: "Tables, chaises, nappes, housses et décoration événementielle",
    image: "https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=600&h=400&fit=crop",
    featured: false
  },
  {
    id: "materiel",
    name: "Matériel et Accessoires",
    slug: "materiel-accessoires",
    description: "Sonorisation, éclairage, chauffage et accessoires",
    image: "https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?w=600&h=400&fit=crop",
    featured: false
  },
  {
    id: "gonflables",
    name: "Gonflables et Jeux",
    slug: "gonflables-jeux",
    description: "Structures gonflables, jeux et animations pour enfants et adultes",
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&h=400&fit=crop",
    featured: false
  },
  {
    id: "restauration",
    name: "Restauration et Buvette",
    slug: "restauration",
    description: "Vaisselle, verrerie, couverts et matériel de cuisine",
    image: "https://images.unsplash.com/photo-1556910103-1c02745aae4d?w=600&h=400&fit=crop",
    featured: false
  },
  {
    id: "packs",
    name: "PACK TOUT INCLUS",
    slug: "pack-tout-inclus",
    description: "Nos formules clés en main pour un événement sans stress",
    image: "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=600&h=400&fit=crop",
    featured: true,
    highlight: true
  }
];

export const featuredProducts = [
  {
    id: 1,
    name: "Grand Chapiteau 10x15m",
    category: "Barnums et Tentes",
    price: "490€/jour",
    image: "https://images.unsplash.com/photo-1675376616537-c8aa9ddc9977?w=400&h=300&fit=crop",
    featured: true,
    description: "Chapiteau modulable idéal pour mariages et grands événements"
  },
  {
    id: 2,
    name: "Barnum Pliant 3x6m",
    category: "Barnums et Tentes",
    price: "85€/jour",
    image: "https://images.unsplash.com/photo-1618106494700-4b0049e83ed8?w=400&h=300&fit=crop",
    featured: false,
    description: "Barnum professionnel facile à monter"
  },
  {
    id: 3,
    name: "Pack Mariage 100 personnes",
    category: "Pack Tout Inclus",
    price: "1 890€",
    image: "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=400&h=300&fit=crop",
    featured: true,
    highlight: true,
    description: "Chapiteau + mobilier + décoration + éclairage"
  },
  {
    id: 4,
    name: "Chaise Napoléon Blanche",
    category: "Mobilier",
    price: "4€/jour",
    image: "https://images.unsplash.com/photo-1503602642458-232111445657?w=400&h=300&fit=crop",
    featured: false,
    description: "Chaise élégante pour réceptions"
  },
  {
    id: 5,
    name: "Tente Stretch 10x10m",
    category: "Barnums et Tentes",
    price: "390€/jour",
    image: "https://images.unsplash.com/photo-1478146059778-26028b07395a?w=400&h=300&fit=crop",
    featured: true,
    description: "Tente design et moderne pour événements haut de gamme"
  },
  {
    id: 6,
    name: "Pack Entreprise 50 pers.",
    category: "Pack Tout Inclus",
    price: "990€",
    image: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=400&h=300&fit=crop",
    featured: true,
    highlight: true,
    description: "Solution complète événements corporate"
  }
];

export const packsToutInclus = [
  {
    id: 1,
    name: "Pack Essentiel",
    persons: "32 personnes",
    price: "À partir de 390€",
    includes: ["Barnum 4x8m", "32 Chaises", "6 Tables rectangles", "Éclairage offert"],
    popular: false
  },
  {
    id: 2,
    name: "Pack Fiesta",
    persons: "50 personnes",
    price: "À partir de 590€",
    includes: ["Barnum 5x10m", "50 Chaises", "8 Tables rectangles", "Éclairage guinguette", "Sono et jeux de lumières"],
    popular: false
  },
  {
    id: 3,
    name: "Pack Réception",
    persons: "72 personnes",
    price: "À partir de 790€",
    includes: ["Barnum 6x12m", "72 Chaises", "12 Tables rectangles", "Vaisselle au choix", "Éclairage + Sono offertes"],
    popular: true
  },
  {
    id: 4,
    name: "Pack Événement",
    persons: "96 personnes",
    price: "À partir de 1 490€",
    includes: ["Barnum 8x12m", "Plancher bois", "96 Chaises", "16 Tables rectangles", "Éclairage + Chauffage"],
    popular: false
  },
  {
    id: 5,
    name: "Pack Premium",
    persons: "128 personnes",
    price: "À partir de 2 290€",
    includes: ["Barnum 8x16m", "Plancher bois", "128 Chaises", "21 Tables rectangles", "Vaisselle", "Éclairage + Chauffage", "Pack Sono"],
    popular: false
  },
  {
    id: 6,
    name: "Pack Mariage",
    persons: "100 personnes",
    price: "À partir de 2 390€",
    includes: ["Barnum 8x16m", "Plancher bois", "100 Chaises cérémonie", "10 Tables rondes", "Éclairage Guinguette"],
    popular: true
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Marie D.",
    location: "Le Havre",
    rating: 5,
    comment: "Service impeccable pour notre mariage à Étretat. Le chapiteau était magnifique et l'équipe très professionnelle. Je recommande vivement !",
    date: "Il y a 2 semaines",
    event: "Mariage"
  },
  {
    id: 2,
    name: "Jean-Pierre L.",
    location: "Rouen",
    rating: 5,
    comment: "Excellent rapport qualité-prix pour notre événement d'entreprise. Livraison ponctuelle et installation rapide. Parfait !",
    date: "Il y a 1 mois",
    event: "Séminaire"
  },
  {
    id: 3,
    name: "Sophie M.",
    location: "Honfleur",
    rating: 5,
    comment: "Je recommande vivement ! Très réactifs et à l'écoute de nos besoins. Le pack tout inclus nous a simplifié la vie.",
    date: "Il y a 3 semaines",
    event: "Anniversaire"
  }
];

export const realizations = [
  {
    id: 1,
    title: "Mariage champêtre - Étretat",
    image: "https://images.unsplash.com/photo-1519167758481-83f29da8c8d0?w=600&h=400&fit=crop",
    category: "Mariage",
    location: "Étretat",
    guests: 120
  },
  {
    id: 2,
    title: "Séminaire entreprise - Le Havre",
    image: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=600&h=400&fit=crop",
    category: "Entreprise",
    location: "Le Havre",
    guests: 80
  },
  {
    id: 3,
    title: "Garden Party - Honfleur",
    image: "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=600&h=400&fit=crop",
    category: "Réception",
    location: "Honfleur",
    guests: 60
  },
  {
    id: 4,
    title: "Anniversaire 50 ans - Rouen",
    image: "https://images.unsplash.com/photo-1695393386569-cf141ff2e552?w=600&h=400&fit=crop",
    category: "Anniversaire",
    location: "Rouen",
    guests: 100
  },
  {
    id: 5,
    title: "Festival local - Dieppe",
    image: "https://images.unsplash.com/photo-1675376616537-c8aa9ddc9977?w=600&h=400&fit=crop",
    category: "Festival",
    location: "Dieppe",
    guests: 500
  },
  {
    id: 6,
    title: "Communion - Caen",
    image: "https://images.unsplash.com/photo-1618106494700-4b0049e83ed8?w=600&h=400&fit=crop",
    category: "Religieux",
    location: "Caen",
    guests: 45
  }
];

export const faqItems = [
  {
    question: "Quels sont vos délais de livraison ?",
    answer: "Pour un week-end, le matériel est mis à disposition le vendredi, la reprise se fait le Lundi.\nEn cas de contraintes, nous pouvons convenir d'un départ + tot , Samedi ou retour Dimanche selon nos possibilités.\n\nPour une journée Nous livrons généralement le matériel la veille ou le matin de votre événement et le récupérons le lendemain. Pour les grands événements, nous pouvons organiser une installation plusieurs jours à l'avance."
  },
  {
    question: "Quelle est votre zone de livraison ?",
    answer: "Nous intervenons dans toute la Normandie : Le Havre, Rouen, Caen, Dieppe, Honfleur, Étretat, Fécamp, et leurs environs. Contactez-nous pour les autres destinations."
  },
  {
    question: "Le montage est-il inclus dans le prix ?",
    answer: "Oui, pour les barnums et grandes tentes de + de 60m2, le montage et démontage sont inclus.\n\nPour le petit matériel (tables, chaises, gonflables) et les barnums de taille inferieure à 60m2 (petit et moyen), vous pouvez choisir l'option avec ou sans installation."
  },
  {
    question: "Que comprennent vos packs tout inclus ?",
    answer: "Nos packs incluent la structure (barnum ou chapiteau), le mobilier, la décoration de base, l'éclairage et le service de livraison/installation. Chaque pack est personnalisable selon vos besoins."
  },
  {
    question: "Comment réserver ?",
    answer: "Demandez un devis gratuit via notre formulaire en ligne ou par téléphone. Nous vous envoyons un devis détaillé sous 24h. Un acompte de 30% confirme votre réservation."
  },
  {
    question: "Que se passe-t-il en cas de mauvais temps ?",
    answer: "Nos structures sont conçues pour résister aux intempéries. En cas de conditions météo extrêmes, nous vous contactons pour adapter la solution. Nous proposons également des options de chauffage et fermeture latérale."
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "Comment choisir la taille de son chapiteau ?",
    excerpt: "Guide complet pour déterminer la surface nécessaire selon le nombre d'invités et le type d'événement.",
    image: "https://images.unsplash.com/photo-1675376616537-c8aa9ddc9977?w=600&h=400&fit=crop",
    date: "15 juin 2025",
    category: "Conseils"
  },
  {
    id: 2,
    title: "Tendances décoration mariage 2026",
    excerpt: "Découvrez les styles qui feront sensation cette année : bohème, minimaliste, champêtre chic...",
    image: "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=600&h=400&fit=crop",
    date: "8 juin 2025",
    category: "Tendances"
  },
  {
    id: 3,
    title: "Organiser un événement d'entreprise réussi",
    excerpt: "Les clés pour un séminaire ou une soirée corporate mémorable : checklist et conseils.",
    image: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=600&h=400&fit=crop",
    date: "1er juin 2025",
    category: "Entreprise"
  }
];

export const localSeoLinks = [
  { name: "Le Havre", slug: "location-materiel-evenementiel-le-havre" },
  { name: "Étretat", slug: "location-barnum-etretat" },
  { name: "Gonfreville", slug: "location-chapiteau-gonfreville" },
  { name: "Honfleur", slug: "location-materiel-reception-honfleur" },
  { name: "Rouen", slug: "location-barnum-rouen" },
  { name: "Dieppe", slug: "location-chapiteau-dieppe" },
  { name: "Caen", slug: "location-materiel-evenementiel-caen" },
  { name: "Fécamp", slug: "location-barnum-fecamp" },
  { name: "Deauville", slug: "location-chapiteau-deauville" },
  { name: "Lisieux", slug: "location-materiel-reception-lisieux" }
];

export const companyInfo = {
  story: "Depuis 2015, Barnum Événement accompagne les particuliers et professionnels de Normandie dans l'organisation de leurs événements. Notre expertise et notre parc matériel de qualité nous permettent de répondre à toutes vos demandes, du petit anniversaire au grand mariage.",
  values: [
    { title: "Qualité", description: "Matériel professionnel régulièrement entretenu et contrôlé" },
    { title: "Service", description: "Équipe réactive et à l'écoute de vos besoins" },
    { title: "Proximité", description: "Présents sur toute la Normandie avec un service personnalisé" }
  ],
  stats: [
    { number: "500+", label: "Événements/an" },
    { number: "10 ans", label: "D'expérience" },
    { number: "98%", label: "Clients satisfaits" },
    { number: "300+", label: "Produits" }
  ]
};

// Base de données des chapiteaux et tentes
export const chapiteauxDatabase = [
  {
    id: "chapiteau-3x6",
    type: "chapiteau",
    name: "CHAPITEAU 3X6",
    surface: 18,
    width: 3,
    length: 6,
    capacityMin: 18,
    capacityMax: 24,
    capacityStanding: 35,
    perimeter: 18,
    hasWindows: true,
    hasDoors: true,
    fireResistant: true,
    assemblySystem: "par clips",
    image: "https://images.unsplash.com/photo-1618106494700-4b0049e83ed8?w=600&h=400&fit=crop",
    pricing: {
      lawnRental: 27,
      hardGroundRental: 29,
      installationLawn: 30,
      ecoFormulaLawn: 480
    }
  },
  {
    id: "chapiteau-4x6",
    type: "chapiteau",
    name: "CHAPITEAU 4X6",
    surface: 24,
    width: 4,
    length: 6,
    capacityMin: 24,
    capacityMax: 32,
    capacityStanding: 45,
    perimeter: 20,
    hasWindows: true,
    hasDoors: true,
    fireResistant: true,
    assemblySystem: "par clips",
    image: "https://images.unsplash.com/photo-1618106494700-4b0049e83ed8?w=600&h=400&fit=crop",
    pricing: {
      lawnRental: 165,
      hardGroundRental: 150,
      installationLawn: 30,
      ecoFormulaLawn: 265
    }
  },
  {
    id: "chapiteau-4x8",
    type: "chapiteau",
    name: "CHAPITEAU 4X8",
    surface: 32,
    width: 4,
    length: 8,
    capacityMin: 32,
    capacityMax: 42,
    capacityStanding: 60,
    perimeter: 24,
    hasWindows: true,
    hasDoors: true,
    fireResistant: true,
    assemblySystem: "par clips",
    image: "https://images.unsplash.com/photo-1618106494700-4b0049e83ed8?w=600&h=400&fit=crop",
    pricing: {
      lawnRental: 195,
      hardGroundRental: 170,
      installationLawn: 30,
      ecoFormulaLawn: 295
    }
  },
  {
    id: "chapiteau-5x6",
    type: "chapiteau",
    name: "CHAPITEAU 5X6",
    surface: 30,
    width: 5,
    length: 6,
    capacityMin: 30,
    capacityMax: 40,
    capacityStanding: 55,
    perimeter: 22,
    hasWindows: true,
    hasDoors: true,
    fireResistant: true,
    assemblySystem: "par clips",
    image: "https://images.unsplash.com/photo-1618106494700-4b0049e83ed8?w=600&h=400&fit=crop",
    pricing: {
      lawnRental: 235,
      hardGroundRental: 200,
      installationLawn: 40,
      ecoFormulaLawn: 355
    }
  },
  {
    id: "chapiteau-5x8",
    type: "chapiteau",
    name: "CHAPITEAU 5X8",
    surface: 40,
    width: 5,
    length: 8,
    capacityMin: 40,
    capacityMax: 52,
    capacityStanding: 75,
    perimeter: 26,
    hasWindows: true,
    hasDoors: true,
    fireResistant: true,
    assemblySystem: "par clips",
    image: "https://images.unsplash.com/photo-1618106494700-4b0049e83ed8?w=600&h=400&fit=crop",
    pricing: {
      lawnRental: 220,
      hardGroundRental: 195,
      installationLawn: 30,
      ecoFormulaLawn: 320
    }
  },
  {
    id: "chapiteau-5x10",
    type: "chapiteau",
    name: "CHAPITEAU 5X10",
    surface: 50,
    width: 5,
    length: 10,
    capacityMin: 50,
    capacityMax: 65,
    capacityStanding: 90,
    perimeter: 30,
    hasWindows: true,
    hasDoors: true,
    fireResistant: true,
    assemblySystem: "par clips",
    image: "https://images.unsplash.com/photo-1618106494700-4b0049e83ed8?w=600&h=400&fit=crop",
    pricing: {
      lawnRental: 275,
      hardGroundRental: 230,
      installationLawn: 40,
      ecoFormulaLawn: 395
    }
  },
  {
    id: "chapiteau-5x12",
    type: "chapiteau",
    name: "CHAPITEAU 5X12",
    surface: 60,
    width: 5,
    length: 12,
    capacityMin: 60,
    capacityMax: 78,
    capacityStanding: 110,
    perimeter: 32,
    hasWindows: true,
    hasDoors: true,
    fireResistant: true,
    assemblySystem: "par clips",
    image: "https://images.unsplash.com/photo-1618106494700-4b0049e83ed8?w=600&h=400&fit=crop",
    pricing: {
      lawnRental: 295,
      hardGroundRental: 260,
      installationLawn: 50,
      ecoFormulaLawn: 460
    }
  },
  {
    id: "chapiteau-6x6",
    type: "chapiteau",
    name: "CHAPITEAU 6X6",
    surface: 36,
    width: 6,
    length: 6,
    capacityMin: 36,
    capacityMax: 48,
    capacityStanding: 65,
    perimeter: 24,
    hasWindows: true,
    hasDoors: true,
    fireResistant: true,
    assemblySystem: "par vis / anneaux de serrage",
    image: "https://images.unsplash.com/photo-1675376616537-c8aa9ddc9977?w=600&h=400&fit=crop",
    pricing: {
      lawnRental: 275,
      hardGroundRental: 230,
      installationLawn: 30,
      ecoFormulaLawn: 375
    }
  },
  {
    id: "chapiteau-6x8",
    type: "chapiteau",
    name: "CHAPITEAU 6X8",
    surface: 48,
    width: 6,
    length: 8,
    capacityMin: 48,
    capacityMax: 62,
    capacityStanding: 85,
    perimeter: 28,
    hasWindows: true,
    hasDoors: true,
    fireResistant: true,
    assemblySystem: "par vis / anneaux de serrage",
    image: "https://images.unsplash.com/photo-1675376616537-c8aa9ddc9977?w=600&h=400&fit=crop",
    pricing: {
      lawnRental: 325,
      hardGroundRental: 265,
      installationLawn: 40,
      ecoFormulaLawn: 445
    }
  },
  {
    id: "chapiteau-6x10",
    type: "chapiteau",
    name: "CHAPITEAU 6X10",
    surface: 60,
    width: 6,
    length: 10,
    capacityMin: 60,
    capacityMax: 78,
    capacityStanding: 110,
    perimeter: 32,
    hasWindows: true,
    hasDoors: true,
    fireResistant: true,
    assemblySystem: "par vis / anneaux de serrage",
    image: "https://images.unsplash.com/photo-1675376616537-c8aa9ddc9977?w=600&h=400&fit=crop",
    pricing: {
      lawnRental: 100,
      hardGroundRental: 305,
      installationLawn: 50,
      ecoFormulaLawn: 525
    }
  },
  {
    id: "chapiteau-6x12",
    type: "chapiteau",
    name: "CHAPITEAU 6X12",
    surface: 72,
    width: 6,
    length: 12,
    capacityMin: 72,
    capacityMax: 94,
    capacityStanding: 130,
    perimeter: 34,
    hasWindows: true,
    hasDoors: true,
    fireResistant: true,
    assemblySystem: "par vis / anneaux de serrage",
    image: "https://images.unsplash.com/photo-1675376616537-c8aa9ddc9977?w=600&h=400&fit=crop",
    pricing: {
      lawnRental: 100,
      hardGroundRental: 350,
      installationLawn: 60,
      ecoFormulaLawn: 615
    }
  },
  {
    id: "chapiteau-6x14",
    type: "chapiteau",
    name: "CHAPITEAU 6X14",
    surface: 84,
    width: 6,
    length: 14,
    capacityMin: 84,
    capacityMax: 110,
    capacityStanding: 150,
    perimeter: 36,
    hasWindows: true,
    hasDoors: true,
    fireResistant: true,
    assemblySystem: "par vis / anneaux de serrage",
    image: "https://images.unsplash.com/photo-1675376616537-c8aa9ddc9977?w=600&h=400&fit=crop",
    pricing: {
      lawnRental: 100,
      hardGroundRental: 395,
      installationLawn: 70,
      ecoFormulaLawn: 705
    }
  },
  {
    id: "chapiteau-6x16",
    type: "chapiteau",
    name: "CHAPITEAU 6X16",
    surface: 96,
    width: 6,
    length: 16,
    capacityMin: 96,
    capacityMax: 125,
    capacityStanding: 170,
    perimeter: 38,
    hasWindows: true,
    hasDoors: true,
    fireResistant: true,
    assemblySystem: "par vis / anneaux de serrage",
    image: "https://images.unsplash.com/photo-1675376616537-c8aa9ddc9977?w=600&h=400&fit=crop",
    pricing: {
      lawnRental: 150,
      hardGroundRental: 440,
      installationLawn: 80,
      ecoFormulaLawn: 795
    }
  },
  {
    id: "chapiteau-6x18",
    type: "chapiteau",
    name: "CHAPITEAU 6X18",
    surface: 108,
    width: 6,
    length: 18,
    capacityMin: 108,
    capacityMax: 140,
    capacityStanding: 190,
    perimeter: 40,
    hasWindows: true,
    hasDoors: true,
    fireResistant: true,
    assemblySystem: "par vis / anneaux de serrage",
    image: "https://images.unsplash.com/photo-1675376616537-c8aa9ddc9977?w=600&h=400&fit=crop",
    pricing: {
      lawnRental: 150,
      hardGroundRental: 485,
      installationLawn: 90,
      ecoFormulaLawn: 885
    }
  },
  {
    id: "chapiteau-6x20",
    type: "chapiteau",
    name: "CHAPITEAU 6X20",
    surface: 120,
    width: 6,
    length: 20,
    capacityMin: 120,
    capacityMax: 156,
    capacityStanding: 210,
    perimeter: 42,
    hasWindows: true,
    hasDoors: true,
    fireResistant: true,
    assemblySystem: "par vis / anneaux de serrage",
    image: "https://images.unsplash.com/photo-1675376616537-c8aa9ddc9977?w=600&h=400&fit=crop",
    pricing: {
      lawnRental: 150,
      hardGroundRental: 530,
      installationLawn: 100,
      ecoFormulaLawn: 975
    }
  },
  {
    id: "chapiteau-8x6",
    type: "chapiteau",
    name: "CHAPITEAU 8X6",
    surface: 48,
    width: 8,
    length: 6,
    capacityMin: 48,
    capacityMax: 62,
    capacityStanding: 85,
    perimeter: 28,
    hasWindows: true,
    hasDoors: true,
    fireResistant: true,
    assemblySystem: "avec axe / goupille",
    image: "https://images.unsplash.com/photo-1675376616537-c8aa9ddc9977?w=600&h=400&fit=crop",
    pricing: {
      lawnRental: 285,
      hardGroundRental: 250,
      installationLawn: 30,
      ecoFormulaLawn: 465
    }
  },
  {
    id: "chapiteau-8x8",
    type: "chapiteau",
    name: "CHAPITEAU 8X8",
    surface: 64,
    width: 8,
    length: 8,
    capacityMin: 64,
    capacityMax: 84,
    capacityStanding: 115,
    perimeter: 32,
    hasWindows: true,
    hasDoors: true,
    fireResistant: true,
    assemblySystem: "avec axe / goupille",
    image: "https://images.unsplash.com/photo-1675376616537-c8aa9ddc9977?w=600&h=400&fit=crop",
    pricing: {
      lawnRental: 100,
      hardGroundRental: 360,
      installationLawn: 40,
      ecoFormulaLawn: 595
    }
  },
  {
    id: "chapiteau-8x10",
    type: "chapiteau",
    name: "CHAPITEAU 8X10",
    surface: 80,
    width: 8,
    length: 10,
    capacityMin: 80,
    capacityMax: 104,
    capacityStanding: 145,
    perimeter: 36,
    hasWindows: true,
    hasDoors: true,
    fireResistant: true,
    assemblySystem: "avec axe / goupille",
    image: "https://images.unsplash.com/photo-1675376616537-c8aa9ddc9977?w=600&h=400&fit=crop",
    pricing: {
      lawnRental: 100,
      hardGroundRental: 435,
      installationLawn: 50,
      ecoFormulaLawn: 725
    }
  },
  {
    id: "chapiteau-8x12",
    type: "chapiteau",
    name: "CHAPITEAU 8X12",
    surface: 96,
    width: 8,
    length: 12,
    capacityMin: 96,
    capacityMax: 125,
    capacityStanding: 170,
    perimeter: 38,
    hasWindows: true,
    hasDoors: true,
    fireResistant: true,
    assemblySystem: "avec axe / goupille",
    image: "https://images.unsplash.com/photo-1675376616537-c8aa9ddc9977?w=600&h=400&fit=crop",
    pricing: {
      lawnRental: 100,
      hardGroundRental: 510,
      installationLawn: 60,
      ecoFormulaLawn: 855
    }
  },
  {
    id: "chapiteau-8x14",
    type: "chapiteau",
    name: "CHAPITEAU 8X14",
    surface: 112,
    width: 8,
    length: 14,
    capacityMin: 112,
    capacityMax: 146,
    capacityStanding: 200,
    perimeter: 40,
    hasWindows: true,
    hasDoors: true,
    fireResistant: true,
    assemblySystem: "avec axe / goupille",
    image: "https://images.unsplash.com/photo-1675376616537-c8aa9ddc9977?w=600&h=400&fit=crop",
    pricing: {
      lawnRental: 100,
      hardGroundRental: 585,
      installationLawn: 70,
      ecoFormulaLawn: 985
    }
  },
  {
    id: "chapiteau-8x16",
    type: "chapiteau",
    name: "CHAPITEAU 8X16",
    surface: 128,
    width: 8,
    length: 16,
    capacityMin: 128,
    capacityMax: 166,
    capacityStanding: 230,
    perimeter: 42,
    hasWindows: true,
    hasDoors: true,
    fireResistant: true,
    assemblySystem: "avec axe / goupille",
    image: "https://images.unsplash.com/photo-1675376616537-c8aa9ddc9977?w=600&h=400&fit=crop",
    pricing: {
      lawnRental: 100,
      hardGroundRental: 660,
      installationLawn: 80,
      ecoFormulaLawn: 1115
    }
  },
  // Tentes pliantes
  {
    id: "tente-eco-3x3",
    type: "tente",
    name: "TENTE ECO 3X3",
    surface: 9,
    width: 3,
    length: 3,
    capacityMin: 8,
    capacityMax: 12,
    capacityStanding: 15,
    perimeter: 18,
    hasWindows: true,
    hasDoors: true,
    fireResistant: false,
    assemblySystem: "pliante",
    image: "https://images.unsplash.com/photo-1618106494700-4b0049e83ed8?w=600&h=400&fit=crop",
    pricing: {
      lawnRental: 30,
      hardGroundRental: 30,
      installationLawn: 15,
      ecoFormulaLawn: 65
    }
  },
  {
    id: "tente-pro-3x3",
    type: "tente",
    name: "TENTE PRO 3X3",
    surface: 9,
    width: 3,
    length: 3,
    capacityMin: 8,
    capacityMax: 12,
    capacityStanding: 15,
    perimeter: 18,
    hasWindows: true,
    hasDoors: true,
    fireResistant: false,
    assemblySystem: "pliante",
    image: "https://images.unsplash.com/photo-1618106494700-4b0049e83ed8?w=600&h=400&fit=crop",
    pricing: {
      lawnRental: 55,
      hardGroundRental: 55,
      installationLawn: 15,
      ecoFormulaLawn: 75
    }
  },
  {
    id: "tente-semi-pro-3x4.5",
    type: "tente",
    name: "TENTE SEMI-PRO 3x4,5",
    surface: 13.5,
    width: 3,
    length: 4.5,
    capacityMin: 12,
    capacityMax: 18,
    capacityStanding: 25,
    perimeter: 21,
    hasWindows: true,
    hasDoors: true,
    fireResistant: false,
    assemblySystem: "pliante",
    image: "https://images.unsplash.com/photo-1618106494700-4b0049e83ed8?w=600&h=400&fit=crop",
    pricing: {
      lawnRental: 45,
      hardGroundRental: 45,
      installationLawn: 25,
      ecoFormulaLawn: 90
    }
  },
  {
    id: "tente-semi-pro-3x6",
    type: "tente",
    name: "TENTE SEMI-PRO 3x6",
    surface: 18,
    width: 3,
    length: 6,
    capacityMin: 18,
    capacityMax: 24,
    capacityStanding: 35,
    perimeter: 24,
    hasWindows: true,
    hasDoors: true,
    fireResistant: false,
    assemblySystem: "pliante",
    image: "https://images.unsplash.com/photo-1618106494700-4b0049e83ed8?w=600&h=400&fit=crop",
    pricing: {
      lawnRental: 45,
      hardGroundRental: 45,
      installationLawn: 30,
      ecoFormulaLawn: 120
    }
  },
  {
    id: "tente-eco-3x6",
    type: "tente",
    name: "TENTE ECO 3x6",
    surface: 18,
    width: 3,
    length: 6,
    capacityMin: 18,
    capacityMax: 24,
    capacityStanding: 35,
    perimeter: 24,
    hasWindows: true,
    hasDoors: true,
    fireResistant: false,
    assemblySystem: "pliante",
    image: "https://images.unsplash.com/photo-1618106494700-4b0049e83ed8?w=600&h=400&fit=crop",
    pricing: {
      lawnRental: 30,
      hardGroundRental: 30,
      installationLawn: 30,
      ecoFormulaLawn: 80
    }
  }
];
